var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterSportIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 9.16683H15.4335C15.0693 9.16605 14.7149 9.28458 14.4244 9.5043C14.134 9.72402 13.9235 10.0328 13.8252 10.3835L11.8668 17.3502C11.8542 17.3934 11.8279 17.4315 11.7918 17.4585C11.7558 17.4855 11.7119 17.5002 11.6668 17.5002C11.6218 17.5002 11.5779 17.4855 11.5418 17.4585C11.5058 17.4315 11.4795 17.3934 11.4668 17.3502L6.86683 0.983496C6.85421 0.940222 6.82789 0.902209 6.79183 0.875163C6.75577 0.848116 6.71191 0.833496 6.66683 0.833496C6.62175 0.833496 6.57789 0.848116 6.54183 0.875163C6.50577 0.902209 6.47945 0.940222 6.46683 0.983496L4.5085 7.95016C4.41055 8.29946 4.20131 8.60726 3.91255 8.82684C3.62378 9.04642 3.27126 9.16579 2.9085 9.16683H0.833496",
    stroke: "#846277",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterSportIcon);
export default __webpack_public_path__ + "static/media/footer_sport_icon.ed8b5d224660c1ca4840f063ad09e7cd.svg";
export { ForwardRef as ReactComponent };